"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 457.8 279.62",
    fill: "currentColor",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M517.51,225.18l-161.63-64.5a6.9,6.9,0,0,0-5-.05L179.65,224.68H70.91A6.87,6.87,0,0,0,64,231.56V432.93a6.87,6.87,0,0,0,6.87,6.88H515a6.88,6.88,0,0,0,6.87-6.88V231.56A6.86,6.86,0,0,0,517.51,225.18Zm-354,200.88H137.39V371h26.13Zm-38.5,0H98.64V371H125Zm158.34-27.78V386.12h23v39.73H249.39V386.12h21.82v12.16Zm54.3-28.71V357h25.11v34.91H316.22V381.17a5,5,0,0,0-5-4.95H301V357h24.48v12.56Zm47.14-31.4V326.38h23.78v99.47H398v-29a5,5,0,0,0-5-4.95H372.67V352.06a5,5,0,0,0-4.95-4.95H348.87V326.38h23.78v11.79ZM357.12,413V401.82h31v24H316.22v-24H345V413Zm61.36,13.06V321.43a5,5,0,0,0-5-4.95H343.92a5,5,0,0,0-4.95,4.95v25.68H296.08a5,5,0,0,0-4.95,4.95v24.16H244.44a5,5,0,0,0-4.95,4.95v44.89H197.76V295.31H466V426.06Zm89.61,0H479.76V288.43a6.87,6.87,0,0,0-6.87-6.87h-282a6.87,6.87,0,0,0-6.87,6.87V426.06h-8.12V364.81a6.19,6.19,0,0,0-6.18-6.19H92.46a6.19,6.19,0,0,0-6.19,6.19v61.25H77.79V238.43h103.1a6.8,6.8,0,0,0,2.41-.43l170-63.56,154.84,61.78Z",
      transform: "translate(-64.04 -160.19)"
    })
  });
};

exports.default = Icon;